let items = document.querySelectorAll('header-menu > details');
let currentItemIndex;
items.forEach((item, itemIndex) => {
  const content = item.querySelector('.header__submenu');
  item.addEventListener('mouseover', () => {
    if (
        (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
        (currentItemIndex && currentItemIndex !== itemIndex)
    ) {
      items[currentItemIndex].removeAttribute('open');
    }
    currentItemIndex = itemIndex;
    item.setAttribute('open', 'true');
    const childItems = item.querySelectorAll('header-menu details');
    childItems.forEach((childItem) => {
      const content = childItem.querySelector('.header__submenu');
      const parentMenu = childItem.closest('div.header__submenu');
      childItem.addEventListener('mouseover', () => {
        if (
            (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
            (currentItemIndex && currentItemIndex !== itemIndex)
        ) {
          items[currentItemIndex].removeAttribute('open');
        }
        currentItemIndex = itemIndex;
        childItem.setAttribute('open', 'true');
        parentMenu.classList.add('active');
        content.classList.add('active');
      })
      childItem.addEventListener('mouseleave', () => {
        let close = true;
        const closeTimeout = setTimeout(() => {
          if (close) {
            childItem.removeAttribute('open')
            parentMenu.classList.remove('active')
            content.classList.remove('active')
            void content.offsetWidth;
          }
        }, 200)
        content.addEventListener('mouseover', () => {
          close = false;
        })
        childItem.addEventListener('mouseover', () => {
          clearTimeout(closeTimeout)
        })
      })
      content.addEventListener('mouseleave', () => {
        childItem.removeAttribute('open')
      })
    })
  })
  item.addEventListener('mouseleave', () => {
    let close = true;
    const closeTimeout = setTimeout(() => {
      if (close) item.removeAttribute('open')
    }, 200)
    content.addEventListener('mouseover', () => {
      close = false;
    })
    item.addEventListener('mouseover', () => {
      clearTimeout(closeTimeout)
    })
  })
  content.addEventListener('mouseleave', () => {
    item.removeAttribute('open')
  })
})
